const Research = () => import("@/components/research/Research.vue");
const RequestTracking = () =>
  import("@/components/requests/RequestTracking.vue");
const MyProfile = () => import("@/components/MyProfile.vue");

export default [
  {
    path: "",
    redirect: "research/client",
  },
  {
    path: "research/client",
    name: "client",
    component: Research,
    props: { bpRole: "client" },
  },
  {
    path: "research/supplier",
    name: "supplier",
    component: Research,
    props: { bpRole: "supplier" },
  },
  {
    path: "request-tracking",
    name: "RequestTracking",
    component: RequestTracking,
  },
  {
    path: "profile",
    name: "my-profile",
    component: MyProfile,
  },
];
